/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RepairConfigRequest
 */
export interface RepairConfigRequest {
  /**
   *
   * @type {string}
   * @memberof RepairConfigRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the RepairConfigRequest interface.
 */
export function instanceOfRepairConfigRequest(
  value: object,
): value is RepairConfigRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function RepairConfigRequestFromJSON(json: any): RepairConfigRequest {
  return RepairConfigRequestFromJSONTyped(json, false);
}

export function RepairConfigRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RepairConfigRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function RepairConfigRequestToJSON(json: any): RepairConfigRequest {
  return RepairConfigRequestToJSONTyped(json, false);
}

export function RepairConfigRequestToJSONTyped(
  value?: RepairConfigRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
